import { MatDialogRef } from '@angular/material/dialog';
import { TransportManagementProfileDetails } from '../models';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

export class TransportManagementProfileItemBriefLoad {
  public static readonly type = '[TransportManagementProfileItemBrief] Load';

  constructor(public payload: number) {}
}

export class TransportManagementProfileItemBriefSave {
  public static readonly type = '[TransportManagementProfileItemBrief] Save';

  constructor(public payload: Partial<TransportManagementProfileDetails>) {}
}

export class TransportManagementProfileItemBriefClone {
  public static readonly type = '[TransportManagementProfileItemBrief] Clone';

  constructor(public payload: Partial<TransportManagementProfileDetails>) {}
}

export class TransportManagementProfileItemBriefDelete {
  public static readonly type = '[TransportManagementProfileItemBrief] Delete';

  constructor(public payload: { dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>; profileId: number }) {}
}

export class TransportManagementProfileItemBriefInitialState {
  public static readonly type = '[TransportManagementProfileItemBrief] Set Initial State';
}
